export default "__VITE_ASSET__C_O35aOq__"